import { onBeforeUnmount, watch, type Ref } from 'vue'

interface ScrollLockState { count: number; overflow: string; paddingRight: string }
const stateKey = Symbol.for('xjlv2.ui.scrollLock')
function state(): ScrollLockState {
  const host = document as Document & { [stateKey]?: ScrollLockState }
  return host[stateKey] ?? (host[stateKey] = { count: 0, overflow: '', paddingRight: '' })
}

/** Share ownership across shell and federated copies instead of releasing another app's lock. */
export function lockScroll() {
  if (typeof document === 'undefined') return
  const lock = state()
  if (lock.count === 0) {
    lock.overflow = document.body.style.overflow
    lock.paddingRight = document.body.style.paddingRight
    const gutter = window.innerWidth - document.documentElement.clientWidth
    if (gutter > 0) document.body.style.paddingRight = `${(Number.parseFloat(getComputedStyle(document.body).paddingRight) || 0) + gutter}px`
    document.body.style.overflow = 'hidden'
    document.body.classList.add('rr-overlay-open')
  }
  lock.count++
}

export function unlockScroll() {
  if (typeof document === 'undefined') return
  const lock = state()
  if (!lock.count) return
  lock.count--
  if (!lock.count) {
    document.body.style.overflow = lock.overflow
    document.body.style.paddingRight = lock.paddingRight
    document.body.classList.remove('rr-overlay-open')
  }
}

export function useScrollLock(isOpen: Readonly<Ref<boolean>>) {
  let owned = false
  watch(isOpen, open => {
    if (open && !owned) { lockScroll(); owned = true }
    else if (!open && owned) { unlockScroll(); owned = false }
  }, { immediate: true })
  onBeforeUnmount(() => { if (owned) { unlockScroll(); owned = false } })
}
